<template>
    <div class="procurementCatalog">
        <HeaderNav
            header-title="采购合同列表"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="content">
            <div class="search">
                <van-search v-model="keyword" placeholder="请输入搜索内容···"></van-search>
            </div>
            <div class="list_box">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                >
                    <div
                        class="list_item"
                        v-for="(item, index) in list"
                        :key="index"
                        @click="toDetail(item)"
                    >
                        <p class="title">
                            <span>合同编号：</span>{{ item.name }}
                            <span :class="['btn', item.type === 1 ? 'btn_ok' : '']">
                                {{ item.type === 1 ? '已确认' : '未确认' }}
                            </span>
                        </p>
                        <div class="ps_box">
                            <p><span>供应商：</span>{{ item.name }}</p>
                            <p><span>采购类型：</span>{{ item.name }}</p>
                            <p><span>物料：</span>{{ item.name }}</p>
                            <p><span>签订日期：</span>{{ item.name }}</p>
                            <p><span>联系人：</span>{{ item.name }}</p>
                            <van-button class="opt_btn" plain type="danger">
                                审批
                            </van-button>
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    name: '',
    components: {
        HeaderNav,
    },
    data() {
        return {
            page: {
                pageindex: 1,
                pagesize: 20,
            },
            keyword: '',
            loading: false,
            finished: false,
            list: [
                {
                    name: '1111111',
                    type: 1,
                },
                {
                    name: '1111111',
                    type: 2,
                },
                {
                    name: '1111111',
                    type: 2,
                },
                {
                    name: '1111111',
                    type: 2,
                },
                {
                    name: '1111111',
                    type: 2,
                },
                {
                    name: '1111111',
                    type: 1,
                },
                {
                    name: '1111111',
                    type: 1,
                },
                {
                    name: '1111111',
                    type: 1,
                },
            ],
        };
    },
    watch: {},
    created() {},
    mounted() {},
    computed: {},
    methods: {
        onLoad() {
            this.loading = false;
            this.finished = true;
            // 异步更新数据
            // this.$axios
            //     .get(`/interfaceApi/sale/want_materia_person/get_contract_list/by_contact_phone/${this.MobilePhone}/?pageIndex=`
            //         + this.page.pageindex + '&pageSize=' + this.page.pagesize)
            //     .then(res => {
            //         // 加载状态结束
            //         this.loading = false;
            //         if (this.page.pageindex === 1) {
            //             this.list = res.rows;
            //         } else {
            //             this.list.push(res.rows);
            //         }
            //         // 数据全部加载完成
            //         if (this.list.length >= res.total) {
            //             this.finished = true;
            //         } else {
            //             this.page.pageindex += 1;
            //         }
            //     }).catch(error => {
            //         Toast(error.ErrorCode.Message);
            //     });
        },
        toDetail(item) {
            this.$router.push({
                path: '/procurementCatalogDetail', query: {
                    id: item.engineering_id,
                    contract_number: item.contract_number,
                    contract_version_id: item.contract_version_id,
                } });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.procurementCatalog
    width 100%
    height 100%
    background #F0F0F0
    .content
        width 100%
        height calc(100% - 44rpx)
        margin-top 44rpx
        >>>.van-search
            background #EAEAEA !important
            height 45rpx !important
        >>>.van-search__content
            background #fff !important
        .list_box
            width 100%
            height calc(100% - 45rpx)
            overflow-y scroll
            padding 15px
            .list_item
                background #fff
                margin-bottom 15rpx
                box-shadow: 0px 0px 3px 0px #b5b5b5;
                border-radius: 8rpx;
                position relative
                .title
                    width 100%
                    height 50rpx
                    background #F8F8F8
                    margin-bottom 0 !important
                    display flex
                    align-items center
                    padding-left 20rpx
                    box-shadow: 0px 2px 3px -2px #b5b5b5;
                    font-size 16rpx
                    font-weight: 550;
                    position relative
                    border-radius: 8rpx 8rpx 0 0;
                    span
                        color: #000 !important
                    .btn
                        position absolute
                        top 0
                        right 0
                        color #fff !important
                        font-size 13rpx !important
                        background: #f86565;
                        padding 2rpx 5rpx
                        border-radius: 0 8rpx
                        font-weight: 500 !important;
                        &.btn_ok
                            background #ccc !important
                .ps_box
                    padding 15px
                p
                    margin-bottom 10px
                    color #333
                    span
                        color #777
                    &last-child
                        margin-bottom 0
                >>>.van-button--plain.van-button--danger
                    background: #fcebec;
                    width: 60rpx;
                    height 25rpx
                    position absolute
                    bottom 25rpx
                    right 10rpx

</style>
